import { render, staticRenderFns } from "./standaardvolgordes.vue?vue&type=template&id=247a7b9f&"
import script from "./standaardvolgordes.ts?vue&type=script&lang=ts&"
export * from "./standaardvolgordes.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports